import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "11",
  height: "14",
  viewBox: "0 0 11 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 13L4 7L1 1",
      stroke: "white",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6 13L9 7L6 1",
      stroke: "white",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }